"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4579,1526],{

/***/ 70359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useAdyen; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var utils_adyen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82399);








var useAdyen = function() {
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)(), env = ref.env, locale = ref.locale, country = ref.country;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var getAdyenInstance = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(props) {
            var adyen, core, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,utils_adyen__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(country)
                        ];
                    case 1:
                        adyen = _state.sent();
                        _tmp = {};
                        return [
                            4,
                            adyen.default((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_tmp.locale = locale, _tmp.environment = env.adyenEnv, _tmp.clientKey = env.adyenClientKey, _tmp.paymentMethodsConfiguration = {
                                card: {
                                    hasHolderName: true,
                                    holderNameRequired: true,
                                    positionHolderNameOnTop: true
                                },
                                billdesk_online: {
                                    showPayButton: false
                                },
                                onlinebanking_IN: {
                                    showPayButton: false
                                },
                                billdesk_wallet: {
                                    showPayButton: false
                                }
                            }, _tmp.translations = (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, locale, {
                                "creditCard.holderName.placeholder": " ",
                                "creditCard.numberField.placeholder": " ",
                                "creditCard.expiryDateField.placeholder": " ",
                                "creditCard.cvcField.placeholder": " ",
                                "creditCard.cvcField.placeholder.3digits": " ",
                                "creditCard.cvcField.placeholder.4digits": " ",
                                "error.va.sf-cc-dat.01": t("validDate")
                            }), _tmp), props))
                        ];
                    case 2:
                        core = _state.sent();
                        return [
                            2,
                            core
                        ];
                }
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }(), [
        env.adyenEnv,
        env.adyenClientKey,
        locale,
        t,
        country
    ]);
    return getAdyenInstance;
};


/***/ }),

/***/ 34843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useApplePay; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70169);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77480);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20368);
/* harmony import */ var utils_payments_apple__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40981);






var useApplePay = function(params) {
    var ref;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslate */ .qM)();
    var countryCode = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_2__/* .useSiteConfig */ .N)().countryCode;
    var cart = (ref = params.cartResult.data) === null || ref === void 0 ? void 0 : ref.activeCart;
    var totalText = "Puma ".concat(countryCode.toLocaleUpperCase());
    var createLineItems = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(cart) {
        var ref, ref1;
        var ref2, ref3, ref4, _price, _price1, ref5;
        return {
            newLineItems: [
                {
                    label: t("applePayItemsTotal"),
                    amount: ((ref2 = cart === null || cart === void 0 ? void 0 : cart.subTotal) !== null && ref2 !== void 0 ? ref2 : 0).toFixed(2),
                    type: "final"
                },
                {
                    label: t("applePayTax"),
                    amount: ((ref3 = cart === null || cart === void 0 ? void 0 : cart.taxTotal) !== null && ref3 !== void 0 ? ref3 : 0).toFixed(2),
                    type: "final"
                },
                {
                    label: t("applePayShipment"),
                    amount: ((ref4 = cart === null || cart === void 0 ? void 0 : (ref = cart.shipment) === null || ref === void 0 ? void 0 : (ref1 = ref.shipmentMethod) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref4 !== void 0 ? ref4 : 0).toFixed(2),
                    type: "final"
                },
                {
                    label: t("orderDiscount"),
                    amount: ((cart === null || cart === void 0 ? void 0 : cart.orderAdjustments) || []).reduce(function(sum, item) {
                        return sum + ((_price = item.price) !== null && _price !== void 0 ? _price : 0);
                    }, 0).toFixed(2),
                    type: "final"
                },
                {
                    label: t("appleShippingDiscount"),
                    amount: ((cart === null || cart === void 0 ? void 0 : cart.shippingAdjustments) || []).reduce(function(sum, item) {
                        return sum + ((_price1 = item.price) !== null && _price1 !== void 0 ? _price1 : 0);
                    }, 0).toFixed(2),
                    type: "final"
                }, 
            ],
            newTotal: {
                label: totalText,
                amount: ((ref5 = cart === null || cart === void 0 ? void 0 : cart.estimatedTotal) !== null && ref5 !== void 0 ? ref5 : 0).toFixed(2)
            }
        };
    }, [
        t,
        totalText
    ]);
    var mapAppleEventToAddressInput = function(event) {
        var billingContact = event.payment.billingContact;
        var shippingContact = event.payment.shippingContact;
        var basketId = cart === null || cart === void 0 ? void 0 : cart.id;
        return [
            {
                address1: shippingContact.addressLines[0],
                address2: shippingContact.addressLines[1],
                basketId: basketId,
                city: shippingContact.locality,
                countryCode: shippingContact.countryCode.toUpperCase(),
                firstName: shippingContact.givenName,
                lastName: shippingContact.familyName,
                phone: shippingContact.phoneNumber,
                postalCode: shippingContact.postalCode,
                stateCode: shippingContact.administrativeArea,
                email: shippingContact.emailAddress || billingContact.emailAddress,
                useAsBilling: false
            },
            {
                address1: billingContact.addressLines[0],
                address2: billingContact.addressLines[1],
                basketId: basketId,
                city: billingContact.locality,
                countryCode: billingContact.countryCode.toUpperCase(),
                firstName: billingContact.givenName,
                lastName: billingContact.familyName,
                postalCode: billingContact.postalCode,
                stateCode: billingContact.administrativeArea,
                phone: billingContact.phoneNumber || shippingContact.phoneNumber
            }, 
        ];
    };
    /**
   * Called when the the `ApplePayJS.ApplePayShippingContactSelectedEvent` is
   * successful. *
   */ var getShippingContactUpdateForSuccess = function(params) {
        var ref, ref1;
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, createLineItems(params.addressResult)), {
            newShippingMethods: (ref = params.addressResult) === null || ref === void 0 ? void 0 : (ref1 = ref.shipmentMethodInfo) === null || ref1 === void 0 ? void 0 : ref1.availableShipmentMethods.map(utils_payments_apple__WEBPACK_IMPORTED_MODULE_3__/* .transformShipmentMethod */ .p_)
        });
    };
    /**
   * Called when the the `ApplePayJS.ApplePayShippingContactSelectedEvent` is
   * missing the fields required for tax calculation.
   *
   */ var getShippingContactUpdateForMissingTaxFields = function() {
        var ref;
        return {
            errors: [
                new ApplePayError("shippingContactInvalid", "postalCode", t("applePayError")), 
            ],
            newTotal: {
                label: totalText,
                amount: ((ref = cart === null || cart === void 0 ? void 0 : cart.estimatedTotal) !== null && ref !== void 0 ? ref : 0).toFixed(2)
            }
        };
    };
    var getShippingContactUpdateForShippingAddressMutationError = function() {
        var ref;
        return {
            errors: [
                new ApplePayError("shippingContactInvalid", "addressLines", "Postal code error"), 
            ],
            newTotal: {
                label: totalText,
                amount: ((ref = cart === null || cart === void 0 ? void 0 : cart.estimatedTotal) !== null && ref !== void 0 ? ref : 0).toFixed(2)
            }
        };
    };
    // Apple does not give us (for privacy && sec concerns) the address1 and names.
    // Only when the fingerprint is recognised (oncompletepayment).
    // We need to update the address regardless, because of taxes.
    // But then we and up with Dummy values in the UI.
    // Same thing as with PayPal, so if payment is cancelled, we transfer carts.
    var generateUpdateShippingAddressInputFromAppleEvent = function(event) {
        var ref, ref1;
        var ref2;
        return {
            address1: "Temporary",
            basketId: cart.id,
            city: event.shippingContact.locality || "",
            countryCode: (ref2 = (ref = event.shippingContact) === null || ref === void 0 ? void 0 : (ref1 = ref.countryCode) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) !== null && ref2 !== void 0 ? ref2 : "",
            firstName: event.shippingContact.givenName || "Temporary",
            lastName: event.shippingContact.familyName || "Temporary",
            phone: "Temporary",
            postalCode: event.shippingContact.postalCode || "",
            stateCode: event.shippingContact.administrativeArea || "",
            useAsBilling: true
        };
    };
    return {
        createLineItems: createLineItems,
        getShippingContactUpdateForMissingTaxFields: getShippingContactUpdateForMissingTaxFields,
        generateUpdateShippingAddressInputFromAppleEvent: generateUpdateShippingAddressInputFromAppleEvent,
        getShippingContactUpdateForSuccess: getShippingContactUpdateForSuccess,
        getShippingContactUpdateForShippingAddressMutationError: getShippingContactUpdateForShippingAddressMutationError,
        mapAppleEventToAddressInput: mapAppleEventToAddressInput
    };
};


/***/ }),

/***/ 23644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ usePayPal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59312);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37678);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79758);
/* harmony import */ var utils_isCartInStock__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9688);
/* harmony import */ var _useCart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69771);
/* harmony import */ var _useFeature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53625);










var usePayPal = function(pauseCartFetch) {
    var payPalEnabled = (0,_useFeature__WEBPACK_IMPORTED_MODULE_5__/* .useFeature */ .S)(utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PaymentMethod.PAYPAL */ .XL.PAYPAL);
    var ref = (0,_useCart__WEBPACK_IMPORTED_MODULE_4__/* .useCart */ .j)({
        pause: pauseCartFetch || utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isServer */ .sk
    }), cart = ref.cart, cartResult = ref.cartResult;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_2__/* .usePayWithPayPalMutation */ ._xu)(), 2), payPalResult = ref1[0], payPal = ref1[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var startPayPal = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var ref, payPalOperationResult, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!payPalEnabled || !(cart === null || cart === void 0 ? void 0 : cart.id) || cartResult.stale || !(0,utils_isCartInStock__WEBPACK_IMPORTED_MODULE_9__/* .isCartInStock */ .c)(cartResult) || !(cart === null || cart === void 0 ? void 0 : cart.products.length)) {
                        return [
                            2
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        payPal((_tmp.input = {
                            basketId: cart === null || cart === void 0 ? void 0 : cart.id,
                            feHost: window.location.host
                        }, _tmp))
                    ];
                case 1:
                    payPalOperationResult = _state.sent();
                    if (!((ref = payPalOperationResult.data) === null || ref === void 0 ? void 0 : ref.payPal)) {
                        return [
                            2
                        ];
                    }
                    window.sessionStorage.setItem(utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAYMENT_METHOD_SESSION_STORAGE_ENTRY.PayPal */ .X9.PayPal, payPalOperationResult.data.payPal.orderNo);
                    if (payPalOperationResult.data.payPal.url) {
                        router.push(payPalOperationResult.data.payPal.url);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        cart,
        cartResult,
        payPal,
        payPalEnabled,
        router
    ]);
    return [
        {
            fetching: payPalResult.fetching,
            error: undefined
        },
        startPayPal, 
    ];
};


/***/ }),

/***/ 24223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useServerSidePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5341);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _useIsServer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64724);



var useServerSidePage = function() {
    // FIXME: This is not safe for hydration, and will result in a mismatch. The
    // initial render state on the client MUST match the server.
    var isServer = (0,_useIsServer__WEBPACK_IMPORTED_MODULE_1__/* .useIsServer */ .w)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState("object" !== "undefined"), 2), canRender = ref[0], setCanRender = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        setCanRender(!isServer);
    }, [
        isServer
    ]);
    return canRender;
};


/***/ }),

/***/ 81526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ComponentType; }
/* harmony export */ });
var ComponentType;
(function(ComponentType) {
    ComponentType["PRIMARY"] = "PRIMARY";
    ComponentType["SECONDARY"] = "SECONDARY";
})(ComponentType || (ComponentType = {}));


/***/ }),

/***/ 5511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useEmplifiTrackNewOrderCbStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6805);
/* harmony import */ var zustand_react_shallow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53248);


var _useEmplifiTrackNewOrderCbStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)(function(set) {
    return {
        emplifiTrackNewOrderCb: null,
        setEmplifiTrackNewOrderCb: function(value) {
            return set({
                emplifiTrackNewOrderCb: value
            });
        }
    };
});
// https://github.com/pmndrs/zustand#selecting-multiple-state-slices
var useEmplifiTrackNewOrderCbStore = function() {
    var ref = _useEmplifiTrackNewOrderCbStore((0,zustand_react_shallow__WEBPACK_IMPORTED_MODULE_1__/* .useShallow */ .N)(function(state) {
        return {
            emplifiTrackNewOrderCb: state.emplifiTrackNewOrderCb,
            setEmplifiTrackNewOrderCb: state.setEmplifiTrackNewOrderCb
        };
    })), emplifiTrackNewOrderCb = ref.emplifiTrackNewOrderCb, setEmplifiTrackNewOrderCb = ref.setEmplifiTrackNewOrderCb;
    return {
        emplifiTrackNewOrderCb: emplifiTrackNewOrderCb,
        setEmplifiTrackNewOrderCb: setEmplifiTrackNewOrderCb
    };
}; // ─── Usage ───────────────────────────────────────────────────────────────────
 //
 // const { emplifiTrackNewOrderCb, setEmplifiTrackNewOrderCb } = useEmplifiTrackNewOrderCbStore();
 //
 // if (!emplifiTrackNewOrderCb) {
 //   setEmplifiTrackNewOrderCb(() => { console.log("test"); });
 // } else {
 //   emplifiTrackNewOrderCb();
 // }
 //
 // ─────────────────────────────────────────────────────────────────────────────


/***/ }),

/***/ 64844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ AdyenApplePayButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(60074);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var hooks_useAdyen__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70359);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37678);
/* harmony import */ var hooks_useServerSidePage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24223);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20368);
/* harmony import */ var utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40981);
/* harmony import */ var hooks_useApplePay__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34843);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(79758);
/* harmony import */ var utils_addPaymentToSessionStorage__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(10128);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83168);
/* harmony import */ var hooks_useCart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69771);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(53625);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70868);
/* harmony import */ var store_emplifiTrackNewOrderCbStore__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5511);
/* provided dependency */ var Buffer = __webpack_require__(30816)["Buffer"];






















var AdyenApplePayButton = function(props) {
    var ref, ref1;
    var canRender = (0,hooks_useServerSidePage__WEBPACK_IMPORTED_MODULE_7__/* .useServerSidePage */ .X)();
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useValidateApplePayMerchantMutation */ .gPj)(), 2), validateApplePayMerchant = ref2[1];
    var getAdyenInstance = (0,hooks_useAdyen__WEBPACK_IMPORTED_MODULE_4__/* .useAdyen */ .y)();
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useUpdateShipmentMethodMutation */ .ejx)(), 2), updateShipmentMethod = ref3[1];
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useUpdateShippingAddressMutation */ .Iav)(), 2), updateShippingAddress = ref4[1];
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useUpdateBillingAddressMutation */ .$It)(), 2), updateBillingAddress = ref5[1];
    var applePaySupportedNetworks = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)().applePaySupportedNetworks;
    var emplifiTrackNewOrderCb = (0,store_emplifiTrackNewOrderCbStore__WEBPACK_IMPORTED_MODULE_16__/* .useEmplifiTrackNewOrderCbStore */ .k)().emplifiTrackNewOrderCb;
    /**
   * `true` when we set up the adyen SDK and / or remounting the component.
   */ var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(true), 2), initializing = ref6[0], setInitializing = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), paymentSheetOpen = ref7[0], setPaymentSheetOpen = ref7[1];
    var applePayContainerDomRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var applePayAdyenElementRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var stateRef = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
    var ref8 = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_8__/* .useSiteConfig */ .N)(), countryCode = ref8.countryCode, localizeUrlPath = ref8.localizeUrlPath, currency = ref8.currency, env = ref8.env;
    var isApplePayEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_14__/* .useFeature */ .S)(utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .PaymentMethod.APPLE_PAY */ .XL.APPLE_PAY);
    var cancelApplePayCallback = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(variables) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                setPaymentSheetOpen(false);
                return [
                    2,
                    cancelApplePay(variables)
                ];
            });
        });
        return function cancelApplePayCallback(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref9 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useCancelApplePayMutation */ .gRK)(), 2), cancelApplePay = ref9[1];
    var ref10 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useStartAdyenPaymentMutation */ .MdU)(), 2), startAdyenPayment = ref10[1];
    var shouldInitialize = canRender && utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__/* .canStartAppleSheet */ .C1 && isApplePayEnabled && env.adyenClientKey;
    var ref11 = (0,hooks_useCart__WEBPACK_IMPORTED_MODULE_13__/* .useCart */ .j)({
        pause: utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .isServer */ .sk || !shouldInitialize
    }), cart = ref11.cart, cartResult = ref11.cartResult;
    var basketId = (ref = cartResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.activeCart) === null || ref1 === void 0 ? void 0 : ref1.id;
    var failOrder = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(param) {
            var component, error, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        component = param.component, error = param.error;
                        component === null || component === void 0 ? void 0 : component.unmount();
                        window.sessionStorage.removeItem("payment-method");
                        if (!basketId) return [
                            3,
                            2
                        ];
                        _tmp = {};
                        return [
                            4,
                            cancelApplePay((_tmp.basketId = basketId, _tmp))
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        component === null || component === void 0 ? void 0 : component.mount(applePayContainerDomRef.current);
                        setPaymentSheetOpen(false);
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_20__/* .captureException */ .Tb(error);
                        return [
                            2
                        ];
                }
            });
        });
        return function failOrder(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var cartHasProducts = cart === null || cart === void 0 ? void 0 : cart.products.some(function(product) {
        return product.__typename !== "GiftCardCartItem";
    });
    var mountApplePayButton = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(component) {
            var isAvailable, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        return [
                            4,
                            component.isAvailable()
                        ];
                    case 1:
                        isAvailable = _state.sent();
                        if (isAvailable && applePayContainerDomRef.current) {
                            component.mount(applePayContainerDomRef.current);
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        error = _state.sent();
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_20__/* .captureException */ .Tb(error);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setInitializing(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(component) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var ref12 = (0,hooks_useApplePay__WEBPACK_IMPORTED_MODULE_10__/* .useApplePay */ .M)({
        cartResult: cartResult
    }), createLineItems = ref12.createLineItems, generateUpdateShippingAddressInputFromAppleEvent = ref12.generateUpdateShippingAddressInputFromAppleEvent, getShippingContactUpdateForMissingTaxFields = ref12.getShippingContactUpdateForMissingTaxFields, getShippingContactUpdateForShippingAddressMutationError = ref12.getShippingContactUpdateForShippingAddressMutationError, getShippingContactUpdateForSuccess = ref12.getShippingContactUpdateForSuccess, mapAppleEventToAddressInput = ref12.mapAppleEventToAddressInput;
    var initializeAdyenApplePay = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, adyen, ref3, ref4, ref5, ref6, _price, _price1, applePayElement, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(basketId && shouldInitialize)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        getAdyenInstance()
                    ];
                case 1:
                    adyen = _state.sent();
                    _tmp = {};
                    applePayElement = adyen === null || adyen === void 0 ? void 0 : adyen.create("applepay", (_tmp.onValidateMerchant = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(resolve, reject, validationUrl) {
                            var ref, operationResult, _tmp;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _tmp = {};
                                        return [
                                            4,
                                            validateApplePayMerchant((_tmp.input = {
                                                validationUrl: validationUrl,
                                                domainName: window.location.host
                                            }, _tmp))
                                        ];
                                    case 1:
                                        operationResult = _state.sent();
                                        if ((ref = operationResult.data) === null || ref === void 0 ? void 0 : ref.validateApplePayMerchant) {
                                            resolve(JSON.parse(operationResult.data.validateApplePayMerchant));
                                        }
                                        reject("Could not generate merchant validation response.");
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, reject, validationUrl) {
                            return _ref.apply(this, arguments);
                        };
                    }(), _tmp.amount = {
                        value: (((ref3 = cart === null || cart === void 0 ? void 0 : cart.estimatedTotal) !== null && ref3 !== void 0 ? ref3 : 0) * 100).toFixed(2),
                        currency: currency.code
                    }, _tmp.countryCode = countryCode.toUpperCase(), _tmp.supportedNetworks = applePaySupportedNetworks, _tmp.shippingMethods = cart === null || cart === void 0 ? void 0 : (ref = cart.shipmentMethodInfo) === null || ref === void 0 ? void 0 : ref.availableShipmentMethods.filter(function(m) {
                        return cartHasProducts ? true : m.id === "Email";
                    }).map(utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__/* .transformShipmentMethod */ .p_), _tmp.requiredShippingContactFields = [
                        "postalAddress",
                        "name",
                        "phone",
                        "email", 
                    ], _tmp.requiredBillingContactFields = [
                        "postalAddress",
                        "name"
                    ], _tmp.lineItems = [
                        {
                            label: t("applePayItemsTotal"),
                            amount: ((ref4 = cart === null || cart === void 0 ? void 0 : cart.subTotal) !== null && ref4 !== void 0 ? ref4 : 0).toFixed(2),
                            type: "final"
                        },
                        {
                            label: t("applePayTax"),
                            amount: ((ref5 = cart === null || cart === void 0 ? void 0 : cart.taxTotal) !== null && ref5 !== void 0 ? ref5 : 0).toFixed(2),
                            type: "final"
                        },
                        {
                            label: t("applePayShipment"),
                            amount: ((ref6 = cart === null || cart === void 0 ? void 0 : (ref1 = cart.shipment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shipmentMethod) === null || ref2 === void 0 ? void 0 : ref2.price) !== null && ref6 !== void 0 ? ref6 : 0).toFixed(2),
                            type: "final"
                        },
                        {
                            label: t("orderDiscount"),
                            amount: cart === null || cart === void 0 ? void 0 : cart.orderAdjustments.reduce(function(sum, item) {
                                return sum + ((_price = item.price) !== null && _price !== void 0 ? _price : 0);
                            }, 0).toFixed(2),
                            type: "final"
                        },
                        {
                            label: t("appleShippingDiscount"),
                            amount: cart === null || cart === void 0 ? void 0 : cart.shippingAdjustments.reduce(function(sum, item) {
                                return sum + ((_price1 = item.price) !== null && _price1 !== void 0 ? _price1 : 0);
                            }, 0).toFixed(2),
                            type: "final"
                        }, 
                    ], _tmp.onClick = function(resolve) {
                        setPaymentSheetOpen(true);
                        resolve();
                    }, _tmp.onSubmit = function(state) {
                        stateRef.current = state;
                    }, _tmp.onShippingContactSelected = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(resolve, _reject, event) {
                            var ref, updateShippingAddressOperationResult, _tmp, cartResult, _tmp1;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__/* .hasAllFieldsForTaxCalculation */ .Mp)(event)) {
                                            return [
                                                2,
                                                resolve(getShippingContactUpdateForMissingTaxFields())
                                            ];
                                        }
                                        _tmp = {};
                                        return [
                                            4,
                                            updateShippingAddress((_tmp.input = generateUpdateShippingAddressInputFromAppleEvent(event), _tmp))
                                        ];
                                    case 1:
                                        updateShippingAddressOperationResult = _state.sent();
                                        cartResult = (ref = updateShippingAddressOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShippingAddress;
                                        if (!cartResult) {
                                            return [
                                                2,
                                                resolve(getShippingContactUpdateForShippingAddressMutationError())
                                            ];
                                        }
                                        _tmp1 = {};
                                        resolve(getShippingContactUpdateForSuccess((_tmp1.addressResult = cartResult, _tmp1)));
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, _reject, event) {
                            return _ref.apply(this, arguments);
                        };
                    }(), _tmp.onAuthorized = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(resolve, reject, event) {
                            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, _tmp, _tmp1, _tmp2, ref12, shippingInput, billingInput, updateShippingAddressPromise, _tmp3, _tmp4, updateBillingAddressOperationResult, _tmp5, _tmp6, stringifiedPaymentData, input, _tmp7, operationResult, _tmp8, _tmp9, _tmp10;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!cart) return [
                                            2
                                        ];
                                        if (!(((ref = event.payment.shippingContact) === null || ref === void 0 ? void 0 : (ref1 = ref.countryCode) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()) !== countryCode.toUpperCase())) return [
                                            3,
                                            2
                                        ];
                                        _tmp = {};
                                        return [
                                            4,
                                            cancelApplePayCallback((_tmp.basketId = cart.id, _tmp))
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2,
                                            reject(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS)
                                        ];
                                    case 2:
                                        if (!!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__/* .ensureAddressFields */ .Nt)(event.payment.shippingContact)) return [
                                            3,
                                            4
                                        ];
                                        _tmp1 = {};
                                        return [
                                            4,
                                            cancelApplePayCallback((_tmp1.basketId = cart.id, _tmp1))
                                        ];
                                    case 3:
                                        _state.sent();
                                        return [
                                            2,
                                            reject(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS)
                                        ];
                                    case 4:
                                        if (!!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_9__/* .ensureAddressFields */ .Nt)(event.payment.billingContact)) return [
                                            3,
                                            6
                                        ];
                                        _tmp2 = {};
                                        return [
                                            4,
                                            cancelApplePayCallback((_tmp2.basketId = cart.id, _tmp2))
                                        ];
                                    case 5:
                                        _state.sent();
                                        return [
                                            2,
                                            reject(ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS)
                                        ];
                                    case 6:
                                        ref12 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(mapAppleEventToAddressInput(event), 2), shippingInput = ref12[0], billingInput = ref12[1];
                                        _tmp3 = {};
                                        return [
                                            4,
                                            updateShippingAddress((_tmp3.input = shippingInput, _tmp3))
                                        ];
                                    case 7:
                                        updateShippingAddressPromise = _state.sent();
                                        if (!updateShippingAddressPromise.error) return [
                                            3,
                                            9
                                        ];
                                        _tmp4 = {};
                                        return [
                                            4,
                                            cancelApplePayCallback((_tmp4.basketId = cart.id, _tmp4))
                                        ];
                                    case 8:
                                        _state.sent();
                                        return [
                                            2,
                                            reject(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS)
                                        ];
                                    case 9:
                                        _tmp5 = {};
                                        return [
                                            4,
                                            updateBillingAddress((_tmp5.input = billingInput, _tmp5))
                                        ];
                                    case 10:
                                        updateBillingAddressOperationResult = _state.sent();
                                        if (!updateBillingAddressOperationResult.error) return [
                                            3,
                                            12
                                        ];
                                        _tmp6 = {};
                                        return [
                                            4,
                                            cancelApplePayCallback((_tmp6.basketId = cart.id, _tmp6))
                                        ];
                                    case 11:
                                        _state.sent();
                                        return [
                                            2,
                                            reject(ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS)
                                        ];
                                    case 12:
                                        stringifiedPaymentData = JSON.stringify(event.payment.token.paymentData);
                                        _tmp7 = {};
                                        input = (_tmp7.basketId = basketId, _tmp7.adyenPaymentData = {
                                            applePayToken: Buffer.from(stringifiedPaymentData).toString("base64"),
                                            paymentMethodType: _generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .AdyenPaymentMethod.ApplePay */ ._Q8.ApplePay
                                        }, _tmp7);
                                        if (typeof ((ref2 = stateRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.checkoutAttemptId) === "string") {
                                            input.adyenPaymentData.checkoutAttemptId = stateRef.current.data.checkoutAttemptId;
                                        }
                                        if (typeof ((ref4 = stateRef.current) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.clientStateDataIndicator) === "string") {
                                            input.adyenPaymentData.clientStateDataIndicator = stateRef.current.data.clientStateDataIndicator;
                                        }
                                        if (typeof ((ref6 = stateRef.current) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.riskData) === null || ref8 === void 0 ? void 0 : ref8.clientData) === "string") {
                                            input.adyenPaymentData.riskData = {
                                                clientData: stateRef.current.data.riskData.clientData
                                            };
                                        }
                                        _tmp8 = {};
                                        return [
                                            4,
                                            startAdyenPayment((_tmp8.input = input, _tmp8))
                                        ];
                                    case 13:
                                        operationResult = _state.sent();
                                        if (((ref9 = operationResult.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.startAdyenPayment) === null || ref10 === void 0 ? void 0 : ref10.resultCode) !== "Authorised" || !((ref11 = operationResult.data) === null || ref11 === void 0 ? void 0 : ref11.startAdyenPayment.orderNo)) {
                                            return [
                                                2,
                                                reject(ApplePaySession.STATUS_FAILURE)
                                            ];
                                        }
                                        // no errors -> track order with Emplifi
                                        emplifiTrackNewOrderCb === null || emplifiTrackNewOrderCb === void 0 ? void 0 : emplifiTrackNewOrderCb();
                                        _tmp9 = {};
                                        (0,utils_addPaymentToSessionStorage__WEBPACK_IMPORTED_MODULE_21__/* .addPaymentToSessionStorage */ .u)((_tmp9.orderNo = operationResult.data.startAdyenPayment.orderNo, _tmp9.paymentMethod = utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .PaymentMethod.APPLE_PAY */ .XL.APPLE_PAY, _tmp9));
                                        resolve(ApplePaySession.STATUS_SUCCESS);
                                        _tmp10 = {};
                                        router.push((_tmp10.pathname = localizeUrlPath("/checkout/confirmation"), _tmp10.query = {
                                            orderNo: operationResult.data.startAdyenPayment.orderNo
                                        }, _tmp10));
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, reject, event) {
                            return _ref.apply(this, arguments);
                        };
                    }(), _tmp.onShippingMethodSelected = function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(function(resolve, _reject, event) {
                            var ref, updateShipmentOperationResult, _tmp;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_19__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!cart) return [
                                            2
                                        ];
                                        _tmp = {};
                                        return [
                                            4,
                                            updateShipmentMethod((_tmp.input = {
                                                shippingMethodId: event.shippingMethod.identifier,
                                                basketId: cart.id
                                            }, _tmp))
                                        ];
                                    case 1:
                                        updateShipmentOperationResult = _state.sent();
                                        if (!((ref = updateShipmentOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShipmentMethod)) {
                                            return [
                                                2,
                                                resolve(createLineItems(cart))
                                            ];
                                        }
                                        resolve(createLineItems(updateShipmentOperationResult.data.updateShipmentMethod));
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(resolve, _reject, event) {
                            return _ref.apply(this, arguments);
                        };
                    }(), _tmp.onError = function(error, component) {
                        failOrder({
                            component: component,
                            error: error
                        });
                    }, _tmp.showPayButton = false, _tmp));
                    applePayAdyenElementRef.current = applePayElement;
                    mountApplePayButton(applePayElement);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- stable refs
    }), [
        basketId,
        shouldInitialize
    ]);
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        initializeAdyenApplePay();
    }, [
        initializeAdyenApplePay
    ]);
    if (!shouldInitialize) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ref: applePayContainerDomRef,
        "data-test-id": "adyen-payment-iframe",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_15__/* .Button */ .z, {
            className: "w-full h-14 bg-white border-puma-black-700 hover:(bg-neutral-20 border-neutral-20)",
            dataTestId: "adyen-apple-pay-button",
            label: "Apple Pay",
            disabled: props.disabled || paymentSheetOpen || initializing || !cart || cartResult.stale,
            loading: initializing || !cart || cartResult.stale,
            lang: router.query.locale,
            onClick: function(e) {
                e.preventDefault();
                applePayAdyenElementRef.current.submit();
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED, {
                    ecommerce: {
                        name: utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED,
                        value: "Apple Pay"
                    }
                });
                (0,utils_analytics__WEBPACK_IMPORTED_MODULE_12__/* .paymentClickEvent */ .UM)();
            },
            type: "button",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO$, {
                name: "payment-apple-pay",
                size: "9xl"
            })
        })
    });
};


/***/ }),

/***/ 91574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ AmazonPayButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34209);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53625);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77480);
/* harmony import */ var hooks_useAmazon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88440);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79758);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83168);









var AmazonPayButton = function(param) {
    var disabled = param.disabled;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslate */ .qM)();
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_5__/* .useSiteConfig */ .N)(), env = ref.env, localizeUrlPath = ref.localizeUrlPath, amazonPayButtonOptions = ref.amazonPayButtonOptions;
    var isMountRender = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
    var isAmazonPayEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_2__/* .useFeature */ .S)(utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .PaymentMethod.AMAZON_PAY */ .XL.AMAZON_PAY);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScriptLoaded = ref1[0], setIsScriptLoaded = ref1[1];
    var loadAmazonScript = (0,hooks_useAmazon__WEBPACK_IMPORTED_MODULE_4__/* .useAmazon */ .i)().loadAmazonScript;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var amazonPayButton = document.getElementById("AmazonPayButton");
        if (!isAmazonPayEnabled || !amazonPayButton) return;
        if (!utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .isServer */ .sk && isMountRender.current && (window === null || window === void 0 ? void 0 : window.OffAmazonPayments)) {
            isMountRender.current = false;
            var params = {
                type: "PwA",
                color: amazonPayButtonOptions === null || amazonPayButtonOptions === void 0 ? void 0 : amazonPayButtonOptions.color,
                size: amazonPayButtonOptions === null || amazonPayButtonOptions === void 0 ? void 0 : amazonPayButtonOptions.size,
                useAmazonAddressBook: true,
                authorization: function() {
                    var ref;
                    var loginOptions = {
                        scope: env.amazonPayScope,
                        popup: true
                    };
                    window === null || window === void 0 ? void 0 : (ref = window.amazon) === null || ref === void 0 ? void 0 : ref.Login.authorize(loginOptions, localizeUrlPath("/amazonpay/redirect"));
                }
            };
            window === null || window === void 0 ? void 0 : window.OffAmazonPayments.Button("AmazonPayButton", env.amazonPayMerchantId, params);
        }
    }, [
        amazonPayButtonOptions === null || amazonPayButtonOptions === void 0 ? void 0 : amazonPayButtonOptions.color,
        amazonPayButtonOptions === null || amazonPayButtonOptions === void 0 ? void 0 : amazonPayButtonOptions.size,
        env.amazonPayMerchantId,
        env.amazonPayScope,
        isAmazonPayEnabled,
        isScriptLoaded,
        localizeUrlPath, 
    ]);
    if (!isAmazonPayEnabled) return null;
    loadAmazonScript(setIsScriptLoaded);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "AmazonPayButton",
                className: (0,twind__WEBPACK_IMPORTED_MODULE_8__.tw)("flex justify-center items-center w-full", disabled ? "pointer-events-none opacity-40" : ""),
                onClick: function() {
                    return (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .paymentClickEvent */ .UM)();
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "flex justify-center items-center w-full text-xs",
                "data-test-id": "amazon-pay-button-note",
                children: t("amazonPayButtonNote")
            })
        ]
    });
};


/***/ }),

/***/ 74503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ApplePayButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5341);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(59312);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86677);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(60074);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12601);
/* harmony import */ var _generated_graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37678);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);
/* harmony import */ var hooks_useRadial__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42849);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79758);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53625);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83168);
/* harmony import */ var hooks_useCart__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69771);
/* harmony import */ var utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40981);
/* harmony import */ var hooks_useApplePay__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(34843);
/* harmony import */ var utils_forter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63179);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70868);




















var ApplePayButton = function(param) {
    var disabled = param.disabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__/* .useSiteConfig */ .N)(), countryCode = ref.countryCode, currency = ref.currency, localizeUrlPath = ref.localizeUrlPath, env = ref.env;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .usePayWithApplePayMutation */ .O70)(), 2), applePay = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useConfirmApplePayMutation */ .gcU)(), 2), confirmApplePay = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useCancelApplePayMutation */ .gRK)(), 2), cancelApplePay = ref3[1];
    var ref4 = (0,hooks_useRadial__WEBPACK_IMPORTED_MODULE_6__/* .useRadial */ .KS)(), radialFingerPrint = ref4.radialFingerPrint, radialFrontendContext = ref4.radialFrontendContext;
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useUpdateShippingAddressMutation */ .Iav)(), 2), updateShippingAddress = ref5[1];
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useUpdateBillingAddressMutation */ .$It)(), 2), updateBillingAddress = ref6[1];
    var ref7 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)((0,_generated_graphql__WEBPACK_IMPORTED_MODULE_4__/* .useUpdateShipmentMethodMutation */ .ejx)(), 2), updateShipmentMethod = ref7[1];
    var ref8 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), isAppleAvailable = ref8[0], setAppleAvailable = ref8[1];
    var isApplePayEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_9__/* .useFeature */ .S)(utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .PaymentMethod.APPLE_PAY */ .XL.APPLE_PAY);
    var totalText = "Puma ".concat(countryCode.toLocaleUpperCase());
    var applePaySupportedNetworks = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_7__/* .useSiteConfig */ .N)().applePaySupportedNetworks;
    var ref9 = (0,hooks_useCart__WEBPACK_IMPORTED_MODULE_11__/* .useCart */ .j)({
        pause: !isAppleAvailable || utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .isServer */ .sk
    }), cart = ref9.cart, cartResult = ref9.cartResult;
    var cancelApplePayCallback = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(variables) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                return [
                    2,
                    cancelApplePay(variables)
                ];
            });
        });
        return function cancelApplePayCallback(variables) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref10 = (0,hooks_useApplePay__WEBPACK_IMPORTED_MODULE_13__/* .useApplePay */ .M)({
        cartResult: cartResult
    }), createLineItems = ref10.createLineItems, getShippingContactUpdateForMissingTaxFields = ref10.getShippingContactUpdateForMissingTaxFields, generateUpdateShippingAddressInputFromAppleEvent = ref10.generateUpdateShippingAddressInputFromAppleEvent, getShippingContactUpdateForSuccess = ref10.getShippingContactUpdateForSuccess, getShippingContactUpdateForShippingAddressMutationError = ref10.getShippingContactUpdateForShippingAddressMutationError, mapAppleEventToAddressInput = ref10.mapAppleEventToAddressInput;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        if (utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__/* .canStartAppleSheet */ .C1) {
            var canMakePayment = ApplePaySession.canMakePayments();
            var notUsingAdyen = !env.adyenClientKey;
            setAppleAvailable(canMakePayment && isApplePayEnabled && notUsingAdyen);
        }
    }, [
        isApplePayEnabled,
        env.adyenClientKey
    ]);
    var handleApplePay = react__WEBPACK_IMPORTED_MODULE_1__.useCallback(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
        var ref, ref1, ref2, cartHasProducts, _subTotal, _taxTotal, ref3, _price, _price1, _estimatedTotal, session, _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
            _tmp = {};
            try {
                ;
                if (!isApplePayEnabled || !cart) {
                    return [
                        2
                    ];
                }
                cartHasProducts = cart.products.some(function(product) {
                    return product.__typename !== "GiftCardCartItem";
                });
                ;
                session = new ApplePaySession(4, (_tmp.countryCode = countryCode.toUpperCase(), _tmp.currencyCode = currency.code, _tmp.supportedNetworks = applePaySupportedNetworks, _tmp.merchantCapabilities = [
                    "supports3DS"
                ], _tmp.shippingMethods = (ref = cart.shipmentMethodInfo) === null || ref === void 0 ? void 0 : ref.availableShipmentMethods.filter(function(m) {
                    return cartHasProducts ? true : m.id === "Email";
                }).map(utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__/* .transformShipmentMethod */ .p_), _tmp.requiredShippingContactFields = [
                    "postalAddress",
                    "name",
                    "phone",
                    "email", 
                ], _tmp.requiredBillingContactFields = [
                    "postalAddress",
                    "name"
                ], _tmp.lineItems = [
                    {
                        label: t("applePayItemsTotal"),
                        amount: ((_subTotal = cart.subTotal) !== null && _subTotal !== void 0 ? _subTotal : 0).toFixed(2),
                        type: "final"
                    },
                    {
                        label: t("applePayTax"),
                        amount: ((_taxTotal = cart.taxTotal) !== null && _taxTotal !== void 0 ? _taxTotal : 0).toFixed(2),
                        type: "final"
                    },
                    {
                        label: t("applePayShipment"),
                        amount: ((ref3 = (ref1 = cart.shipment) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.shipmentMethod) === null || ref2 === void 0 ? void 0 : ref2.price) !== null && ref3 !== void 0 ? ref3 : 0).toFixed(2),
                        type: "final"
                    },
                    {
                        label: "Order discount",
                        amount: cart.orderAdjustments.reduce(function(sum, item) {
                            return sum + ((_price = item.price) !== null && _price !== void 0 ? _price : 0);
                        }, 0).toFixed(2),
                        type: "final"
                    },
                    {
                        label: t("appleShippingDiscount"),
                        amount: cart.shippingAdjustments.reduce(function(sum, item) {
                            return sum + ((_price1 = item.price) !== null && _price1 !== void 0 ? _price1 : 0);
                        }, 0).toFixed(2),
                        type: "final"
                    }, 
                ], _tmp.total = {
                    label: totalText,
                    amount: ((_estimatedTotal = cart.estimatedTotal) !== null && _estimatedTotal !== void 0 ? _estimatedTotal : 0).toFixed(2)
                }, _tmp));
                session.onvalidatemerchant = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(event) {
                        var ref, applePayOperationResult, _tmp;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(cart === null || cart === void 0 ? void 0 : cart.id)) {
                                        return [
                                            2,
                                            session.abort()
                                        ];
                                    }
                                    _tmp = {};
                                    return [
                                        4,
                                        applePay((_tmp.input = {
                                            basketId: cart.id,
                                            url: event.validationURL
                                        }, _tmp))
                                    ];
                                case 1:
                                    applePayOperationResult = _state.sent();
                                    if (!((ref = applePayOperationResult.data) === null || ref === void 0 ? void 0 : ref.applePay)) {
                                        return [
                                            2,
                                            session.abort()
                                        ];
                                    }
                                    session.completeMerchantValidation(applePayOperationResult.data.applePay);
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }();
                session.onshippingmethodselected = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(event) {
                        var ref, updateShipmentOperationResult, _tmp;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!cart) return [
                                        2
                                    ];
                                    _tmp = {};
                                    return [
                                        4,
                                        updateShipmentMethod((_tmp.input = {
                                            shippingMethodId: event.shippingMethod.identifier,
                                            basketId: cart.id
                                        }, _tmp))
                                    ];
                                case 1:
                                    updateShipmentOperationResult = _state.sent();
                                    if (!((ref = updateShipmentOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShipmentMethod)) {
                                        return [
                                            2,
                                            session.completeShippingMethodSelection(createLineItems(cart))
                                        ];
                                    }
                                    session.completeShippingMethodSelection(createLineItems(updateShipmentOperationResult.data.updateShipmentMethod));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }();
                session.oncancel = function(event) {
                    if (!cart) return;
                    cancelApplePayCallback({
                        basketId: cart.id
                    });
                    throw new Error(JSON.stringify(event));
                };
                /**
       * Event handler when the shipping information is changed.
       */ session.onshippingcontactselected = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(event) {
                        var ref, updateShippingAddressOperationResult, _tmp, _tmp1;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__/* .hasAllFieldsForTaxCalculation */ .Mp)(event)) {
                                        return [
                                            2,
                                            session.completeShippingContactSelection(getShippingContactUpdateForMissingTaxFields())
                                        ];
                                    }
                                    _tmp = {};
                                    return [
                                        4,
                                        updateShippingAddress((_tmp.input = generateUpdateShippingAddressInputFromAppleEvent(event), _tmp))
                                    ];
                                case 1:
                                    updateShippingAddressOperationResult = _state.sent();
                                    if (!((ref = updateShippingAddressOperationResult.data) === null || ref === void 0 ? void 0 : ref.updateShippingAddress)) {
                                        return [
                                            2,
                                            session.completeShippingContactSelection(getShippingContactUpdateForShippingAddressMutationError())
                                        ];
                                    }
                                    _tmp1 = {};
                                    session.completeShippingContactSelection(getShippingContactUpdateForSuccess((_tmp1.addressResult = updateShippingAddressOperationResult.data.updateShippingAddress, _tmp1)));
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }();
                session.onpaymentauthorized = function() {
                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function(event) {
                        var ref, ref1, _tmp, _tmp1, ref2, shippingInput, billingInput, updateShippingAddressPromise, _tmp2, _tmp3, updateBillingAddressOperationResult, _tmp4, _tmp5, pData, confirmApplePayOperationResult, _tmp6, placedOrder, _tmp7;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!cart) return [
                                        2
                                    ];
                                    if (!!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__/* .ensureAddressFields */ .Nt)(event.payment.shippingContact)) return [
                                        3,
                                        2
                                    ];
                                    _tmp = {};
                                    return [
                                        4,
                                        cancelApplePayCallback((_tmp.basketId = cart.id, _tmp))
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2,
                                        session.completePayment(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS)
                                    ];
                                case 2:
                                    if (!!(0,utils_payments_apple__WEBPACK_IMPORTED_MODULE_12__/* .ensureAddressFields */ .Nt)(event.payment.billingContact)) return [
                                        3,
                                        4
                                    ];
                                    _tmp1 = {};
                                    return [
                                        4,
                                        cancelApplePayCallback((_tmp1.basketId = cart.id, _tmp1))
                                    ];
                                case 3:
                                    _state.sent();
                                    return [
                                        2,
                                        session.completePayment(ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS)
                                    ];
                                case 4:
                                    ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(mapAppleEventToAddressInput(event), 2), shippingInput = ref2[0], billingInput = ref2[1];
                                    _tmp2 = {};
                                    return [
                                        4,
                                        updateShippingAddress((_tmp2.input = shippingInput, _tmp2))
                                    ];
                                case 5:
                                    updateShippingAddressPromise = _state.sent();
                                    if (!updateShippingAddressPromise.error) return [
                                        3,
                                        7
                                    ];
                                    _tmp3 = {};
                                    return [
                                        4,
                                        cancelApplePayCallback((_tmp3.basketId = cart.id, _tmp3))
                                    ];
                                case 6:
                                    _state.sent();
                                    return [
                                        2,
                                        session.completePayment(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS)
                                    ];
                                case 7:
                                    _tmp4 = {};
                                    return [
                                        4,
                                        updateBillingAddress((_tmp4.input = billingInput, _tmp4))
                                    ];
                                case 8:
                                    updateBillingAddressOperationResult = _state.sent();
                                    if (!updateBillingAddressOperationResult.error) return [
                                        3,
                                        10
                                    ];
                                    _tmp5 = {};
                                    return [
                                        4,
                                        cancelApplePayCallback((_tmp5.basketId = cart.id, _tmp5))
                                    ];
                                case 9:
                                    _state.sent();
                                    return [
                                        2,
                                        session.completePayment(ApplePaySession.STATUS_INVALID_BILLING_POSTAL_ADDRESS)
                                    ];
                                case 10:
                                    pData = event.payment.token.paymentData;
                                    _tmp6 = {};
                                    return [
                                        4,
                                        confirmApplePay((_tmp6.input = {
                                            basketId: cart.id,
                                            paymentData: JSON.stringify(pData),
                                            radialFingerPrint: radialFingerPrint,
                                            radialFrontendContext: radialFrontendContext,
                                            forterToken: (0,utils_forter__WEBPACK_IMPORTED_MODULE_14__/* .getForterToken */ .Ze)()
                                        }, _tmp6))
                                    ];
                                case 11:
                                    confirmApplePayOperationResult = _state.sent();
                                    if (!((ref = confirmApplePayOperationResult.data) === null || ref === void 0 ? void 0 : ref.confirmApplePay)) {
                                        return [
                                            2,
                                            session.completePayment(ApplePaySession.STATUS_FAILURE)
                                        ];
                                    }
                                    placedOrder = (ref1 = confirmApplePayOperationResult.data) === null || ref1 === void 0 ? void 0 : ref1.confirmApplePay;
                                    _tmp7 = {};
                                    if (placedOrder) {
                                        window.sessionStorage.setItem("payment-method", "Apple Pay");
                                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                                        router.push((_tmp7.pathname = localizeUrlPath("/checkout/confirmation"), _tmp7.query = {
                                            orderNo: confirmApplePayOperationResult.data.confirmApplePay.orderNo
                                        }, _tmp7));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(event) {
                        return _ref.apply(this, arguments);
                    };
                }();
                session.begin();
            } catch (e) {
                _sentry_nextjs__WEBPACK_IMPORTED_MODULE_19__/* .captureException */ .Tb(e);
            }
            return [
                2
            ];
        });
    }), [
        cart
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!isAppleAvailable) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_15__/* .Button */ .z, {
        "data-test-id": "apple-pay-button",
        label: "Apple Pay",
        className: "w-full h-14 bg-white border-puma-black-700 hover:(bg-neutral-20 border-neutral-20)",
        disabled: disabled || !cart || cartResult.stale,
        onClick: function() {
            handleApplePay();
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED, {
                ecommerce: {
                    name: utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED,
                    value: "Apple Pay"
                }
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_10__/* .paymentClickEvent */ .UM)();
        },
        type: "button",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO$, {
            name: "payment-apple-pay",
            size: "9xl"
        })
    });
};


/***/ }),

/***/ 12656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ GWPOldDesign; }
});

// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/twind/twind.js + 1 modules
var twind = __webpack_require__(34209);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./utils/media.ts
var media = __webpack_require__(39772);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./ui/components/CloseButton.tsx
var CloseButton = __webpack_require__(6485);
// EXTERNAL MODULE: ./ui/components/Modal.tsx
var Modal = __webpack_require__(51377);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./utils/image.ts
var utils_image = __webpack_require__(75350);
// EXTERNAL MODULE: ./ui/components/Img.tsx
var Img = __webpack_require__(53579);
// EXTERNAL MODULE: ./utils/countingNumbers.ts
var countingNumbers = __webpack_require__(46857);
;// CONCATENATED MODULE: ./ui/components/QuantityDropdown.tsx






var QuantityDropdown = function(param) {
    var className = param.className, quantity = param.quantity, setQuantity = param.setQuantity, _maxQuantity = param.maxQuantity, maxQuantity = _maxQuantity === void 0 ? 6 : _maxQuantity;
    var t = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputSelect */.JDu, {
        id: "qty-dropdown",
        className: (0,twind.tw)("w-[90px] mr-2", className),
        value: quantity.toString(),
        showLabel: false,
        dataTestId: "pdp-quantity-select",
        options: (0,countingNumbers/* countingNumbersAsDropdownList */._)(maxQuantity),
        label: t("quantity"),
        onChange: function(newQty) {
            return setQuantity(Number.parseInt(newQty));
        },
        placeholder: t("qty")
    });
};

// EXTERNAL MODULE: ./ui/components/Sizes/index.ts + 9 modules
var Sizes = __webpack_require__(38913);
// EXTERNAL MODULE: ./ui/components/Styles.tsx
var Styles = __webpack_require__(87260);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/doesSelectedItemMatchInCartItem.ts
var doesSelectedItemMatchInCartItem = function(selected, inCart, giftWithPurchase) {
    if (inCart.__typename !== "ProductCartItem") return false;
    var matchingPromo = giftWithPurchase.id === inCart.bonusItemId;
    var matchingId = selected.id === inCart.product.masterId;
    var matchingSize = selected.size.id === inCart.product.size.value;
    var matchingColor = selected.color === inCart.product.colorValue;
    return matchingPromo && matchingId && matchingSize && matchingColor;
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/findSizeObject.ts

var findSizeObject = function(item, giftWithPurchase) {
    var ref;
    var availableProducts = giftWithPurchase === null || giftWithPurchase === void 0 ? void 0 : (ref = giftWithPurchase.availableProducts) === null || ref === void 0 ? void 0 : ref.map(function(a) {
        if ("id" in a) return a;
        if ("product" in a) return a.product;
        return undefined;
    });
    var product = availableProducts === null || availableProducts === void 0 ? void 0 : availableProducts.find(function(p) {
        var size = false;
        if (p && "styleNumber" in p) {
            // p is VariantProduct
            size = p.styleNumber === item.styleNumber;
        }
        if (p && "variations" in p) {
            // p is Product
            size = !!p.variations.find(function(v) {
                return v.id === item.styleNumber;
            });
        }
        return size;
    });
    var sizeVariant;
    if (product && "styleNumber" in product) {
        // product is VariantProduct
        sizeVariant = product.size;
    }
    if (product && "variations" in product) {
        // product is Product
        var matchingVariant = product.variations.find(function(v) {
            return v.id === item.styleNumber;
        });
        var sizes = matchingVariant ? (0,products/* getSizesFromSizeGroups */.hJ)(matchingVariant.sizeGroups) : [];
        var sizeFound = sizes.find(function(s) {
            return s.id === item.size.value;
        });
        if (sizeFound) sizeVariant = sizeFound;
    }
    return sizeVariant;
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/selectedItemsInCart.ts
var selectedItemsInCart = function(cart, findSizeObjectCallback, giftWithPurchase) {
    if (!(cart === null || cart === void 0 ? void 0 : cart.products) || !giftWithPurchase) return [];
    // Filter all products in cart to return ProductCartItem types that also
    // match the selected giftWithPurchase.id then map them to SelectedItemType.
    return cart.products.filter(function(product) {
        return product.__typename === "ProductCartItem" && product.bonusItemId === giftWithPurchase.id;
    }).map(function(_gift) {
        var gift = _gift;
        return {
            color: gift.product.colorValue,
            colorName: gift.product.colorName,
            id: gift.product.masterId,
            productName: gift.product.name,
            quantity: gift.quantity,
            size: findSizeObjectCallback(gift.product)
        };
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(13583);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/handleUpdateQuantity.ts





// Update quantity of items one at a time to keep cart in sync
var handleUpdateQuantity = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToUpdate, cart, doesSelectedItemMatchInCartItemCallback, updateInCart, currencyCode) {
        var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(cart === null || cart === void 0 ? void 0 : cart.products)) return [
                        2
                    ];
                    res = undefined;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var itemToUpdate, ref, itemToUpdateInCart, _tmp, _tmp1, analyticsItem, _tmp2, _tmp3;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    itemToUpdate = _step.value;
                                    itemToUpdateInCart = cart.products.find(function(inCartItem) {
                                        return doesSelectedItemMatchInCartItemCallback(itemToUpdate, inCartItem);
                                    });
                                    _tmp = {};
                                    if (!itemToUpdateInCart) return [
                                        2,
                                        (_tmp.v = void void 0, _tmp)
                                    ];
                                    _tmp1 = {};
                                    return [
                                        4,
                                        updateInCart((_tmp1.itemId = itemToUpdateInCart.id, _tmp1.quantity = itemToUpdate.quantity, _tmp1.masterId = itemToUpdate.id, _tmp1))
                                    ];
                                case 1:
                                    res = _state.sent();
                                    _tmp2 = {};
                                    _tmp3 = {};
                                    if ((ref = res.data) === null || ref === void 0 ? void 0 : ref.updateItemInCart) {
                                        analyticsItem = (0,analytics/* transformListProductToAnalyticsItem */.pD)((_tmp2.product = itemToUpdate, _tmp2.currency = currencyCode, _tmp2.quantity = itemToUpdate.quantity, _tmp2.categories = {
                                            item_category: undefined
                                        }, _tmp2.itemListId = undefined, _tmp2.itemListName = undefined, _tmp2.index = undefined, _tmp2.size = itemToUpdate.size.label, _tmp2));
                                        (0,analytics/* event */.B)(analytics/* AnalyticsEvents.GA4EC_AddItemToCart */._q.GA4EC_AddItemToCart, (_tmp3.event_name = analytics/* AnalyticsEvents.ADD_ITEM_LIST_TO_CART */._q.ADD_ITEM_LIST_TO_CART, _tmp3.ecommerce = {
                                            item_list_id: undefined,
                                            item_list_name: undefined,
                                            currency: currencyCode,
                                            value: undefined,
                                            item_id_ep: itemToUpdate.id,
                                            item_name_ep: itemToUpdate.productName,
                                            image_type: undefined,
                                            image_number: undefined,
                                            items: [
                                                analyticsItem
                                            ]
                                        }, _tmp3));
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = itemsToUpdate[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        (0,tslib_es6.__values)(_loop())
                    ];
                case 3:
                    _ret = _state.sent();
                    if ((0,_type_of/* default */.Z)(_ret) === "object") return [
                        2,
                        _ret.v
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function handleUpdateQuantity(itemsToUpdate, cart, doesSelectedItemMatchInCartItemCallback, updateInCart, currencyCode) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/handleAddItemsToCart.ts


var handleAddItemsToCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToAdd, addToCart, giftWithPurchase, showMiniCart) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                addToCart(itemsToAdd.map(function(item) {
                    return {
                        productId: item.size.productId,
                        bonusItemId: giftWithPurchase.id,
                        quantity: item.quantity,
                        swatch: item.color,
                        masterId: item.id.split("_")[0]
                    };
                }), undefined, showMiniCart)
            ];
        });
    });
    return function handleAddItemsToCart(itemsToAdd, addToCart, giftWithPurchase, showMiniCart) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/handleRemoveItemFromCart.ts




// Removes items one at a time to keep cart in sync
var handleRemoveItemFromCart = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToRemove, cart, doesSelectedItemMatchInCartItemCallback, removeFromCart) {
        var res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, _ret, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(cart === null || cart === void 0 ? void 0 : cart.products)) return [
                        2
                    ];
                    res = undefined;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _loop = function() {
                        var itemToRemove, itemToRemoveInCart, _tmp, _tmp1;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    itemToRemove = _step.value;
                                    itemToRemoveInCart = cart.products.find(function(inCartItem) {
                                        return doesSelectedItemMatchInCartItemCallback(itemToRemove, inCartItem);
                                    });
                                    _tmp = {};
                                    if (!itemToRemoveInCart) return [
                                        2,
                                        (_tmp.v = void void 0, _tmp)
                                    ];
                                    _tmp1 = {};
                                    return [
                                        4,
                                        removeFromCart((_tmp1.itemId = itemToRemoveInCart.id, _tmp1))
                                    ];
                                case 1:
                                    res = _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = itemsToRemove[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    return [
                        5,
                        (0,tslib_es6.__values)(_loop())
                    ];
                case 3:
                    _ret = _state.sent();
                    if ((0,_type_of/* default */.Z)(_ret) === "object") return [
                        2,
                        _ret.v
                    ];
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        res
                    ];
            }
        });
    });
    return function handleRemoveItemFromCart(itemsToRemove, cart, doesSelectedItemMatchInCartItemCallback, removeFromCart) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(60074);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/handleUpdatingPromoGifts.ts



// When user clicks "Add to cart" we need to figure out which items need to be
// removed from cart, updated in quantity or added to cart. We then call them
// sequentially so we are always operating on the updated cart.
var handleUpdatingPromoGifts = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(handleAddItemsToCartCallback, handleRemoveItemFromCartCallback, handleUpdateQuantityCallback, closeModal, selectedItems, selectedItemsInCartMemo, setLoading, showMiniCart) {
        var itemsToAdd, itemsToUpdate, selectedItemsProductIDs, itemsToRemove, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    setLoading(true);
                    itemsToAdd = [];
                    itemsToUpdate = [];
                    selectedItemsProductIDs = selectedItems.map(function(i) {
                        return i.size.productId;
                    });
                    itemsToRemove = selectedItemsInCartMemo.filter(function(s) {
                        return !selectedItemsProductIDs.includes(s.size.productId);
                    });
                    selectedItems.forEach(function(item) {
                        var matchInCart = selectedItemsInCartMemo.find(function(i) {
                            return i.size.productId === item.size.productId;
                        });
                        // Already in cart, no need to add again.
                        if (matchInCart && matchInCart.quantity === item.quantity) {
                            return;
                        } else if (matchInCart && matchInCart.quantity !== item.quantity) {
                            itemsToUpdate.push(item);
                        } else {
                            itemsToAdd.push(item);
                        }
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        9,
                        10
                    ]);
                    setLoading(true);
                    if (!itemsToRemove.length) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        handleRemoveItemFromCartCallback(itemsToRemove)
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (!itemsToUpdate.length) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        handleUpdateQuantityCallback(itemsToUpdate)
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    if (!itemsToAdd.length) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        handleAddItemsToCartCallback(itemsToAdd, showMiniCart)
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        10
                    ];
                case 8:
                    error = _state.sent();
                    esm_exports/* captureMessage */.uT("Error updating promo gifts");
                    esm_exports/* captureException */.Tb(error);
                    return [
                        3,
                        10
                    ];
                case 9:
                    closeModal();
                    setLoading(false);
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
    return function handleUpdatingPromoGifts(handleAddItemsToCartCallback, handleRemoveItemFromCartCallback, handleUpdateQuantityCallback, closeModal, selectedItems, selectedItemsInCartMemo, setLoading, showMiniCart) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/isMatchForSelectedItem.ts
var isMatchForSelectedItem = function(identifier, selected) {
    var ref;
    var idMatch = identifier.id.indexOf(selected.id) > -1;
    var colorMatch = identifier.color === selected.color;
    var sizeMatch = ((ref = identifier.size) === null || ref === void 0 ? void 0 : ref.id) === selected.size.id;
    return idMatch && colorMatch && sizeMatch;
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/addRemoveSelectedItem.ts


// Remove items from selectedItems array that match id, color, and size
var removeSelectedItem = function(itemToRemove, setSelectedItems, selectedItems) {
    if (!itemToRemove) return;
    var updatedSelectedItems = selectedItems.filter(function(selectedItem) {
        return !isMatchForSelectedItem(itemToRemove, selectedItem);
    });
    setSelectedItems(updatedSelectedItems);
};
// Add new item to selectedItems array
var addSelectedItem = function(itemToAdd, setSelectedItems, selectedItems) {
    setSelectedItems((0,_to_consumable_array/* default */.Z)(selectedItems).concat([
        itemToAdd
    ]));
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/utils/index.ts










;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/GWP.old.ProductSelector.tsx












var GWPOld_ProductSelector = function(param) {
    var addSelectedItem = param.addSelectedItem, excludedColors = param.excludedColors, error = param.error, initialSwatch = param.initialSwatch, maxAllowedQuantity = param.maxAllowedQuantity, product = param.product, removeSelectedItem = param.removeSelectedItem, selectedItems = param.selectedItems, updateSelectedItemQuantity = param.updateSelectedItemQuantity;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var hideEanColorCode = (0,useFeature/* useFeature */.S)("HIDE_EAN_COLOR_CODE");
    var name = product.name, variations = product.variations;
    var ref = (0,react.useState)(1), quantity = ref[0], setQuantity = ref[1];
    var ref1 = (0,react.useState)(), size = ref1[0], setSize = ref1[1];
    var ref2 = (0,react.useState)(function() {
        var ref;
        return ((ref = product.variations) === null || ref === void 0 ? void 0 : ref[0].colorValue) || "";
    }), color = ref2[0], setColor = ref2[1];
    var chosenVariant = variations && variations.find(function(variant) {
        return color ? variant.colorValue === color : initialSwatch ? variant.colorValue === initialSwatch : true;
    });
    var addItem = function(e) {
        e.preventDefault(); // Need this to prevent resetting of color value
        if (size) {
            var ref;
            var giftToAdd = {
                color: color,
                colorName: ((ref = variations.find(function(v) {
                    return v.colorValue === color;
                })) === null || ref === void 0 ? void 0 : ref.colorName) || "",
                id: chosenVariant.id,
                productName: product.name,
                quantity: quantity,
                size: size
            };
            addSelectedItem(giftToAdd);
        }
    };
    var removeItem = (0,react.useCallback)(function() {
        return removeSelectedItem({
            id: chosenVariant.id,
            color: chosenVariant.colorValue,
            size: size
        });
    }, [
        chosenVariant,
        size,
        removeSelectedItem
    ]);
    var updateQuantity = (0,react.useCallback)(function(newQuantity) {
        // Update quantity for quantity dropdown
        setQuantity(newQuantity);
        // if there are selected items, update the quantity there
        if (selectedItems.length && chosenVariant) {
            var item = {
                id: chosenVariant.id,
                color: chosenVariant.colorValue,
                size: size
            };
            updateSelectedItemQuantity(item, newQuantity);
        }
    }, [
        chosenVariant,
        selectedItems,
        size,
        updateSelectedItemQuantity
    ]);
    // Set Default Size
    var sizes = chosenVariant ? (0,products/* getSizesFromSizeGroups */.hJ)(chosenVariant.sizeGroups) : [];
    var defaultSize = sizes.filter(function(f) {
        return f.orderable;
    })[0];
    (0,react.useEffect)(function() {
        setSize(defaultSize);
    }, [
        defaultSize
    ]);
    var isVariantSelected = (0,react.useMemo)(function() {
        if (!chosenVariant || !selectedItems.length) return false;
        return selectedItems.filter(function(selectedItem) {
            var item = {
                id: chosenVariant.id,
                color: chosenVariant.colorValue,
                size: size
            };
            return isMatchForSelectedItem(item, selectedItem);
        }).length > 0;
    }, [
        chosenVariant,
        selectedItems,
        size
    ]);
    // Set the quantity of selected item so it will be reflected in the Quantity
    // Dropdown
    (0,react.useEffect)(function() {
        if (isVariantSelected && chosenVariant) {
            var selectedItem = selectedItems.find(function(item) {
                return isMatchForSelectedItem({
                    id: chosenVariant.id,
                    color: chosenVariant.colorValue,
                    size: size
                }, item);
            });
            if (selectedItem) setQuantity(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity);
        }
    }, [
        isVariantSelected,
        chosenVariant,
        selectedItems,
        size
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        "data-test-id": "gift-purchase-product",
        className: "flex relative items-center p-4 border border-4 rounded",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "grid items-center lg:grid-cols-2 md:grid-cols-2 gap-5",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center bg-puma-black-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* Img */.E, {
                        width: 400,
                        src: (0,utils_image/* resizeProductImage */.QW)(chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.images[0].href, 800),
                        alt: (chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.images[0].alt) || ""
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "space-y-3",
                    children: [
                        !hideEanColorCode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-puma-black-300",
                            children: [
                                "#",
                                chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.id
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "xs:text-xl xl:text-2xl font-bold",
                                    children: name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: "text-xs",
                                    children: [
                                        hideEanColorCode && "".concat(translate("color"), ": "),
                                        chosenVariant === null || chosenVariant === void 0 ? void 0 : chosenVariant.colorName
                                    ]
                                })
                            ]
                        }),
                        variations && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "quickview-modal-swatch-selector",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Styles/* Styles */.z, {
                                desiredSwatch: color,
                                variations: variations.filter(function(variant) {
                                    return !excludedColors.includes(variant.colorName);
                                }),
                                onChange: function(newColor) {
                                    if (color !== newColor) {
                                        setColor(newColor);
                                        setSize(undefined);
                                    }
                                }
                            })
                        }),
                        chosenVariant && /*#__PURE__*/ (0,jsx_runtime.jsx)(Sizes/* Sizes */.u8, {
                            sizeGroups: chosenVariant.sizeGroups,
                            desiredSize: size === null || size === void 0 ? void 0 : size.id,
                            onChange: function(newSize) {
                                setSize(sizes.find(function(size) {
                                    return size.id === newSize;
                                }));
                            },
                            tileSize: Sizes/* TileSizes.SMALL */.ik.SMALL
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantityDropdown, {
                                    quantity: quantity,
                                    setQuantity: updateQuantity,
                                    maxQuantity: maxAllowedQuantity
                                }),
                                isVariantSelected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputCheckbox */.o2J, {
                                    id: "variant-selected",
                                    checked: isVariantSelected,
                                    onChange: removeItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "-ml-2",
                                        children: translate("productSelected")
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                                    dataTestId: "gwp-old-modal-add-button",
                                    className: "flex-1",
                                    label: translate("add"),
                                    variant: "primary",
                                    onClick: addItem,
                                    loading: false
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: error && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: error
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/GWP.old.SelectedItem.tsx




var GWPOld_SelectedItem = function(param) {
    var item = param.item, removeSelectedItem = param.removeSelectedItem;
    var ref;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var onDelete = (0,react.useCallback)(function() {
        return removeSelectedItem(item);
    }, [
        item,
        removeSelectedItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-puma-black-800 py-2.5 px-4 mt-2.5",
        "data-test-id": "selected-bonus-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "font-bold",
                        children: item.productName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                        className: "absolute right-0 top-0",
                        onClick: onDelete,
                        label: "delete",
                        icon: "trash",
                        variant: "ghost",
                        mode: "icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex text-sm",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex-1 flex space-x-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-puma-black-400",
                                children: translate("color")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.colorName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex-1 flex space-x-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-puma-black-400",
                                children: translate("size")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: (ref = item.size) === null || ref === void 0 ? void 0 : ref.label
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "flex-1 flex space-x-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-puma-black-400",
                                children: translate("quantity")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.quantity
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/useGWPModal.ts









var useGWPModal = function(param) {
    var giftWithPurchase = param.giftWithPurchase, cart = param.cart, closeModal = param.closeModal, setLoading = param.setLoading, setError = param.setError;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var currency = (0,useSiteConfig/* useSiteConfig */.N)().currency;
    var ref = (0,useCart/* useCart */.j)(), addToCart = ref.addToCart, updateInCart = ref.updateInCart, removeFromCart = ref.removeFromCart;
    var doesSelectedItemMatchInCartItemCallback = (0,react.useCallback)(function(selected, inCart) {
        return doesSelectedItemMatchInCartItem(selected, inCart, giftWithPurchase);
    }, [
        giftWithPurchase
    ]);
    var findSizeObjectCallback = (0,react.useCallback)(function(item) {
        return findSizeObject(item, giftWithPurchase);
    }, [
        giftWithPurchase
    ]);
    var selectedItemsInCartMemo = (0,react.useMemo)(function() {
        return selectedItemsInCart(cart, findSizeObjectCallback, giftWithPurchase);
    }, [
        cart,
        giftWithPurchase,
        findSizeObjectCallback
    ]);
    var ref1 = (0,react.useState)(selectedItemsInCartMemo), selectedItems = ref1[0], setSelectedItems = ref1[1];
    var handleUpdateQuantityCallback = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToUpdate) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    handleUpdateQuantity(itemsToUpdate, cart, doesSelectedItemMatchInCartItemCallback, updateInCart, currency.code)
                ];
            });
        });
        return function(itemsToUpdate) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        doesSelectedItemMatchInCartItemCallback,
        updateInCart,
        currency.code
    ]);
    var handleAddItemsToCartCallback = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToAdd, showMiniCart) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    handleAddItemsToCart(itemsToAdd, addToCart, giftWithPurchase, showMiniCart)
                ];
            });
        });
        return function(itemsToAdd, showMiniCart) {
            return _ref.apply(this, arguments);
        };
    }(), [
        addToCart,
        giftWithPurchase
    ]);
    // Removes items one at a time to keep cart in sync
    var handleRemoveItemFromCartCallback = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(itemsToRemove) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    handleRemoveItemFromCart(itemsToRemove, cart, doesSelectedItemMatchInCartItemCallback, removeFromCart)
                ];
            });
        });
        return function(itemsToRemove) {
            return _ref.apply(this, arguments);
        };
    }(), [
        cart,
        doesSelectedItemMatchInCartItemCallback,
        removeFromCart
    ]);
    // When user clicks "Add to cart" we need to figure out which items need to be
    // removed from cart, updated in quantity or added to cart. We then call them
    // sequentially so we are always operating on the updated cart.
    var handleUpdatingPromoGiftsCallback = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                handleUpdatingPromoGifts(handleAddItemsToCartCallback, handleRemoveItemFromCartCallback, handleUpdateQuantityCallback, closeModal, selectedItems, selectedItemsInCartMemo, setLoading, props === null || props === void 0 ? void 0 : props.showMiniCart);
                return [
                    2
                ];
            });
        });
        return function(props) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleAddItemsToCartCallback,
        handleRemoveItemFromCartCallback,
        handleUpdateQuantityCallback,
        closeModal,
        selectedItems,
        selectedItemsInCartMemo,
        setLoading, 
    ]);
    // Remove items from selectedItems array that match id, color, and size
    var removeSelectedItemCallback = (0,react.useCallback)(function(itemToRemove) {
        return removeSelectedItem(itemToRemove, setSelectedItems, selectedItems);
    }, [
        setSelectedItems,
        selectedItems
    ]);
    // Add new item to selectedItems array
    var addSelectedItemCallback = (0,react.useCallback)(function(itemToAdd) {
        return addSelectedItem(itemToAdd, setSelectedItems, selectedItems);
    }, [
        selectedItems,
        setSelectedItems
    ]);
    // Updates Quantity of Selected Item
    var updateSelectedItemQuantity = (0,react.useCallback)(function(itemIdentifiers, newQuantity) {
        // if there are selected items, update the quantity there
        if (selectedItems.length) {
            // Update matching selectedItem
            var updatedSelectedItems = selectedItems.map(function(selectedItem) {
                if (isMatchForSelectedItem(itemIdentifiers, selectedItem)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedItem), {
                        quantity: newQuantity
                    });
                } else {
                    return selectedItem;
                }
            });
            setSelectedItems(updatedSelectedItems);
        }
    }, [
        selectedItems,
        setSelectedItems
    ]);
    // Each time selectedItems changes, update selectedQuantity
    var selectedQuantity = (0,react.useMemo)(function() {
        return selectedItems.reduce(function(acc, curr) {
            return acc + curr.quantity;
        }, 0);
    }, [
        selectedItems
    ]);
    // Each time selectedQuantity changes, determine if user has selected more
    // than the max allowed. If so, show error. Otherwise, clear error message.
    (0,react.useEffect)(function() {
        if (giftWithPurchase === null || giftWithPurchase === void 0 ? void 0 : giftWithPurchase.allowedQuantity) {
            if (selectedQuantity > giftWithPurchase.allowedQuantity) {
                setError(t("maxBonusItems", {
                    allowedQuantity: giftWithPurchase.allowedQuantity
                }));
            } else setError(undefined);
        }
    }, [
        giftWithPurchase === null || giftWithPurchase === void 0 ? void 0 : giftWithPurchase.allowedQuantity,
        selectedQuantity,
        setError,
        t
    ]);
    return {
        handleUpdatingPromoGiftsCallback: handleUpdatingPromoGiftsCallback,
        removeSelectedItemCallback: removeSelectedItemCallback,
        addSelectedItemCallback: addSelectedItemCallback,
        updateSelectedItemQuantity: updateSelectedItemQuantity,
        selectedItems: selectedItems,
        selectedQuantity: selectedQuantity
    };
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/GWP.old.Modal.tsx















var GWPOld_Modal = function(param) {
    var cart = param.cart;
    var ref, ref1;
    var translate = (0,useTranslations/* useTranslate */.qM)();
    var setModalOpen = (0,store/* useModalsOpenStore */.wQ)().setModalOpen;
    var hideSelectedBonusItems = (0,useFeature/* useFeature */.S)("HIDE_CALLOUT_MESSAGE");
    var openMiniCart = (0,useMiniCart/* useMiniCart */.lm)().openMiniCart;
    var setPopupOpen = (0,store/* usePopupsOpenStore */.Gd)().setPopupOpen;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(undefined), error = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), showSelectedItems = ref4[0], setShowSelectedItems = ref4[1];
    var isCartPage = router.asPath.includes("/cart");
    var openPopupOrMiniCartAfterClosingModal = (0,react.useCallback)(function() {
        if (!(cart === null || cart === void 0 ? void 0 : cart.products)) return;
        // don't try to open popup or miniCart when user is on Cart page
        if (!isCartPage) {
            if ((0,media/* getIsMobile */.W)()) {
                // in mobile show cart-button-popup
                setPopupOpen("CartButtonPopup", true);
            } else {
                var ref;
                // in desktop show mini-cart with the last item added to the cart
                var lastItemInTheCart = cart === null || cart === void 0 ? void 0 : (ref = cart.products) === null || ref === void 0 ? void 0 : ref[(cart === null || cart === void 0 ? void 0 : cart.products.length) - 1];
                openMiniCart(lastItemInTheCart, true);
            }
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.products,
        isCartPage,
        openMiniCart,
        setPopupOpen
    ]);
    var onClose = (0,react.useCallback)(function() {
        setModalOpen("GWPModal", false);
        openPopupOrMiniCartAfterClosingModal();
    }, [
        openPopupOrMiniCartAfterClosingModal,
        setModalOpen
    ]);
    var giftWithPurchase = cart === null || cart === void 0 ? void 0 : (ref = cart.giftWithPurchases) === null || ref === void 0 ? void 0 : ref.find(function(promo) {
        return !promo.fullfilled;
    });
    var ref5 = useGWPModal({
        closeModal: function() {
            return setModalOpen("GWPModal", false);
        },
        setError: setError,
        setLoading: setLoading,
        cart: cart,
        giftWithPurchase: giftWithPurchase
    }), addSelectedItemCallback = ref5.addSelectedItemCallback, handleUpdatingPromoGiftsCallback = ref5.handleUpdatingPromoGiftsCallback, removeSelectedItemCallback = ref5.removeSelectedItemCallback, updateSelectedItemQuantity = ref5.updateSelectedItemQuantity, selectedItems = ref5.selectedItems, selectedQuantity = ref5.selectedQuantity;
    if (!giftWithPurchase) return null;
    var showTitleBelowCloseButton = (0,media/* getIsMobile */.W)() && (giftWithPurchase === null || giftWithPurchase === void 0 ? void 0 : giftWithPurchase.details) && ((ref1 = giftWithPurchase.details) === null || ref1 === void 0 ? void 0 : ref1.length) > 25;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        onClickOutside: onClose,
        className: "max-w-xl overflow-y-auto",
        variant: "dark",
        dataTestId: "gwp-old-modal-overlay",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            "data-test-id": "gwp-old-modal-body",
            className: "lg:col-span-5 xl:col-span-6 md:space-y-4 xs:border xs:p-8 p-4 xs:rounded-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: (0,twind.tw)([
                        "border-b pb-5 flex desktop:items-end",
                        showTitleBelowCloseButton && "mobile:flex-col-reverse",
                        !showTitleBelowCloseButton && "mobile:items-end", 
                    ]),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-black-100 uppercase text-lg font-bold mobile:pt-2",
                            "data-test-id": "shopping-cart-header",
                            children: !hideSelectedBonusItems && giftWithPurchase.details || translate("bonusItems")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton/* default */.Z, {
                            className: "ml-auto text-sm sm:text-base md:text-lg lg:text-xl",
                            "data-test-id": "gwp-old-modal-close",
                            onClick: onClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "cart-products",
                    className: "flex flex-col flex-grow space-y-10",
                    children: giftWithPurchase.availableProducts.map(function(cartItem, idx) {
                        if (cartItem.__typename !== "ProductWithExclusion") return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GWPOld_ProductSelector, {
                            excludedColors: cartItem.excludedColors,
                            product: cartItem.product,
                            removeSelectedItem: removeSelectedItemCallback,
                            selectedItems: selectedItems,
                            addSelectedItem: addSelectedItemCallback,
                            updateSelectedItemQuantity: updateSelectedItemQuantity,
                            maxAllowedQuantity: giftWithPurchase.allowedQuantity
                        }, "".concat(idx, "-").concat(cartItem.product.id));
                    })
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "flex items-center space-x-3 justify-between text-puma-red border border-puma-red font-bold px-3 py-2 text-sm rounded mb-2 mt-3",
                    role: "alert",
                    "data-test-id": "selection-error",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: error
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                            name: "exclamation-outline",
                            size: "3xl",
                            color: "error"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "border-b flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "flex items-center space-x-2",
                                onClick: function() {
                                    return setShowSelectedItems(!showSelectedItems);
                                },
                                "aria-expanded": showSelectedItems,
                                "aria-controls": "selected-free-gifts-container",
                                "data-test-id": "selected-free-gifts-container-btn",
                                type: "button",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "font-bold text-sm uppercase ",
                                        children: translate("itemsSelected", {
                                            allowed: giftWithPurchase.allowedQuantity,
                                            selected: selectedQuantity
                                        })
                                    }),
                                    selectedItems.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (0,twind.tw)("inline-block transform  ml-auto", showSelectedItems ? "-rotate-90" : "rotate-90"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                            name: "chevron-right",
                                            size: "lg"
                                        })
                                    })
                                ]
                            })
                        }),
                        showSelectedItems && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col space-y-2.5 overflow-y-auto max-h-56",
                            children: selectedItems.map(function(item) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(GWPOld_SelectedItem, {
                                    item: item,
                                    removeSelectedItem: removeSelectedItemCallback
                                }, "".concat(item.id, "-").concat(item.color, "-").concat(item === null || item === void 0 ? void 0 : (ref = item.size) === null || ref === void 0 ? void 0 : ref.id));
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    id: "buttonGroup",
                    className: "flex flex-col space-y-4 pt-4 md:pt-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            disabled: loading || !selectedItems.length || selectedQuantity > giftWithPurchase.allowedQuantity || selectedItems.some(function(item) {
                                return !item.size;
                            }),
                            loading: loading,
                            label: translate("addToCart"),
                            variant: "primary",
                            onClick: function() {
                                return(// don't try to open miniCart when user is on Cart page
                                handleUpdatingPromoGiftsCallback({
                                    showMiniCart: !isCartPage
                                }));
                            },
                            dataTestId: "gwp-old-modal-add-gifts-to-cart"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zxk, {
                            label: translate("noThanks"),
                            variant: "secondary",
                            onClick: onClose,
                            dataTestId: "gwp-old-modal-cancel"
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./ui/elements/Button.tsx + 1 modules
var Button = __webpack_require__(70868);
;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/GWP.old.CalloutButton.tsx





var GWPOld_CalloutButton = function(param) {
    var className = param.className, onClick = param.onClick;
    var hideCalloutMessage = (0,useFeature/* useFeature */.S)("HIDE_CALLOUT_MESSAGE");
    var translate = (0,useTranslations/* useTranslate */.qM)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* Button */.z, {
        dataTestId: "gwp-promo-link",
        className: "w-full ".concat(className),
        onClick: onClick,
        variant: "secondary",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                name: "gift",
                size: "2xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex-grow",
                children: hideCalloutMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "font-bold uppercase",
                    children: translate("bonusItems")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-bold uppercase",
                        children: translate("claimYourGiftItems")
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./ui/components/GiftWithPurchase/OldDesign/index.tsx




var GWPOldDesign = {
    Modal: GWPOld_Modal,
    ProductSelector: GWPOld_ProductSelector,
    SelectedItem: GWPOld_SelectedItem,
    CalloutButton: GWPOld_CalloutButton
};


/***/ }),

/***/ 11222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ isTherePromosButNotASinglePromoClaimed; }
/* harmony export */ });
// for now only allow to 1 promo active in parallel
var isTherePromosButNotASinglePromoClaimed = function(param) {
    var cart = param.cart, giftWithPurchases = param.giftWithPurchases;
    var promos = (cart === null || cart === void 0 ? void 0 : cart.giftWithPurchases) || giftWithPurchases;
    if (!promos || !promos.length) return false;
    return !Boolean(promos === null || promos === void 0 ? void 0 : promos.find(function(e) {
        return e.fullfilled;
    }));
};


/***/ }),

/***/ 69192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GooglePayButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var twind__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34209);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_useCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69771);
/* harmony import */ var hooks_useGooglePay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93548);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20368);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70868);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83168);









var GooglePayButton = function(param) {
    var buttonType = param.buttonType, disabled = param.disabled;
    var language = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_5__/* .useSiteConfig */ .N)().language;
    var ref = (0,hooks_useGooglePay__WEBPACK_IMPORTED_MODULE_4__/* .useGooglePay */ .G)(), enableGooglePay = ref.enableGooglePay, isGooglePayEnabled = ref.isGooglePayEnabled, injectButtonStyles = ref.injectButtonStyles, handleGooglePay = ref.handleGooglePay;
    var ref1 = (0,hooks_useCart__WEBPACK_IMPORTED_MODULE_3__/* .useCart */ .j)({
        pause: !isGooglePayEnabled
    }), cart = ref1.cart, cartResult = ref1.cartResult;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(enableGooglePay, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isGooglePayEnabled) injectButtonStyles(buttonType);
    }, [
        isGooglePayEnabled,
        buttonType
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    if (!isGooglePayEnabled) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, {
        "arial-label": "Google Pay",
        className: (0,twind__WEBPACK_IMPORTED_MODULE_8__.tw)("bg-white border-puma-black-700 !w-full !h-14 hover:(bg-neutral-20 border-neutral-20)", buttonType, buttonType === "pay" && language),
        dataTestId: "google-pay-button",
        disabled: disabled || !cart || cartResult.stale,
        onClick: function() {
            handleGooglePay();
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED, {
                ecommerce: {
                    name: utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED,
                    value: "Google Pay"
                }
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_7__/* .paymentClickEvent */ .UM)();
        },
        type: "button",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
            name: "payment-google-pay",
            size: "9xl"
        })
    });
};


/***/ }),

/***/ 49246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PayPalButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5341);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27378);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12601);
/* harmony import */ var hooks_usePayPal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23644);
/* harmony import */ var ui_elements_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70868);
/* harmony import */ var utils_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83168);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53625);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77480);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79758);










var PayPalButton = function(param) {
    var disabled = param.disabled, loading = param.loading;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_7__/* .useTranslate */ .qM)();
    var isPayPalEnabled = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_6__/* .useFeature */ .S)(utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .PaymentMethod.PAYPAL */ .XL.PAYPAL);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,hooks_usePayPal__WEBPACK_IMPORTED_MODULE_3__/* .usePayPal */ .S)(!isPayPalEnabled), 2), fetching = ref[0].fetching, startPayPal = ref[1];
    if (!isPayPalEnabled) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
        dataTestId: "continue-with-paypal-button",
        className: "w-full bg-white border-puma-black-700 hover:(bg-neutral-20 border-neutral-20)",
        height: "tall",
        label: t("continueWithPayPal"),
        loading: fetching || loading,
        disabled: fetching || loading || disabled,
        onClick: function() {
            startPayPal();
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .AnalyticsEvents.MINICART */ ._q.MINICART, {
                domevent: "button clicked",
                domlabel: "paypal"
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .event */ .B)(utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED, {
                ecommerce: {
                    name: utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .AnalyticsEvents.PAYMENT_TYPE_SELECTED */ ._q.PAYMENT_TYPE_SELECTED,
                    value: "Paypal"
                }
            });
            (0,utils_analytics__WEBPACK_IMPORTED_MODULE_5__/* .paymentClickEvent */ .UM)();
        },
        type: "button",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO$, {
            name: "payment-paypal",
            size: "10xl"
        })
    });
};


/***/ }),

/***/ 87260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Styles; }
/* harmony export */ });
/* unused harmony export shouldDisplayVariant */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17599);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3204);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var twind_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79200);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77480);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53625);
/* harmony import */ var utils_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75350);
/* harmony import */ var _Sizes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38913);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98463);









/** If the `HIDE_SOLD_OUT_COLORS_IN_STYLES_SELECTION` feature flag is enabled,
 * only return colors that are orderable and not marked as sold out. */ var shouldDisplayVariant = function(variant, hideSoldOutColorsInStylesSelection) {
    if (!hideSoldOutColorsInStylesSelection) return true;
    var orderable = variant.orderable, displayOutOfStock = variant.displayOutOfStock;
    var soldOut = displayOutOfStock === null || displayOutOfStock === void 0 ? void 0 : displayOutOfStock.soldout;
    // If the variant is orderable and not marked as sold out, show it.
    return Boolean(orderable && !soldOut);
};
var _obj;
var columnSizes = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, _Sizes__WEBPACK_IMPORTED_MODULE_5__/* .TileSizes.SMALL */ .ik.SMALL, "3rem"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, _Sizes__WEBPACK_IMPORTED_MODULE_5__/* .TileSizes.MEDIUM */ .ik.MEDIUM, "3.6rem"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, _Sizes__WEBPACK_IMPORTED_MODULE_5__/* .TileSizes.LARGE */ .ik.LARGE, "4.6rem"), _obj);
var Styles = function(param) {
    var _variations = param.variations, variations = _variations === void 0 ? [] : _variations, desiredSwatch = param.desiredSwatch, onChange = param.onChange, isHydrating = param.isHydrating, colors = param.colors;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_2__/* .useTranslate */ .qM)();
    var hideSoldOutColorsInStylesSelection = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_3__/* .useFeature */ .S)("HIDE_SOLD_OUT_COLORS_IN_STYLES_SELECTION");
    var sizePickerStyle = {
        gridTemplateColumns: "repeat(auto-fill, minmax(".concat(columnSizes[_Sizes__WEBPACK_IMPORTED_MODULE_5__/* .TileSizes.MEDIUM */ .ik.MEDIUM], ", 1fr))")
    };
    if (isHydrating && (colors === null || colors === void 0 ? void 0 : colors.length)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex flex-col gap-6",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid gap-1",
                style: sizePickerStyle,
                children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Array(colors.length)).map(function(_, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_6__/* .Skeleton */ .O, {
                        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_1__.tw)("w-full aspect-1-1"),
                        delay: "".concat((i + 1) * 100, "ms")
                    }, i);
                })
            })
        });
    }
    var variationsToShow = variations.filter(function(variant) {
        return shouldDisplayVariant(variant, hideSoldOutColorsInStylesSelection);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "style-picker",
        "aria-label": t("styles"),
        role: "radiogroup",
        className: "grid gap-1",
        style: {
            gridTemplateColumns: "repeat(auto-fill, minmax(3.6rem, 1fr))"
        },
        children: variationsToShow.map(function(variation) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                "data-test-id": "color",
                "data-color": variation.colorValue,
                className: (0,twind_style__WEBPACK_IMPORTED_MODULE_1__.tw)("relative flex items-center justify-center flex-none rounded-sm", desiredSwatch === variation.colorValue && "border border-neutral-70", (variation.displayOutOfStock || variation.orderable === false) && "bg-puma-black-700"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "sr-only",
                        children: [
                            variation.colorName,
                            variation.displayOutOfStock || variation.orderable === false ? ": ".concat(t("outOfStock")) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        "aria-hidden": true,
                        src: (0,utils_image__WEBPACK_IMPORTED_MODULE_4__/* .resizeProductImage */ .QW)(variation.preview, 100),
                        alt: variation.colorName || "",
                        loading: "lazy",
                        width: "120",
                        height: "120",
                        className: (0,twind_style__WEBPACK_IMPORTED_MODULE_1__.tw)("w-full", (variation.displayOutOfStock || variation.orderable === false) && "opacity-50")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "radio",
                        name: "swatch",
                        checked: desiredSwatch === variation.colorValue,
                        className: "absolute appearance-none block w-full h-full inset-0 cursor-pointer",
                        tabIndex: 0,
                        onChange: function(e) {
                            return onChange && e.target.checked && onChange(variation.colorValue);
                        }
                    })
                ]
            }, variation.id);
        })
    });
};


/***/ }),

/***/ 10128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ addPaymentToSessionStorage; }
/* harmony export */ });
var addPaymentToSessionStorage = function(param) {
    var orderNoEntryName = param.orderNoEntryName, paymentMethod = param.paymentMethod, orderNo = param.orderNo;
    try {
        if (orderNoEntryName && orderNo) {
            window.sessionStorage.setItem(orderNoEntryName, orderNo);
        }
        window.sessionStorage.setItem("payment-method", paymentMethod);
    } catch (e) {}
};


/***/ }),

/***/ 82399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ isRedirectAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59312);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);



var getAdyenModule = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(country) {
        var adyenCheckout;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(/* import() */[__webpack_require__.e(3451), __webpack_require__.e(3345)]).then(__webpack_require__.bind(__webpack_require__, 9445))
                    ];
                case 1:
                    adyenCheckout = _state.sent();
                    if (true) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 6762).then(__webpack_require__.bind(__webpack_require__, 96762))
                    ];
                case 2:
                    adyenCheckout = _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        adyenCheckout
                    ];
            }
        });
    });
    return function getAdyenModule(country) {
        return _ref.apply(this, arguments);
    };
}();
var isRedirectAction = function(action) {
    return action.type === "redirect";
};
/* harmony default export */ __webpack_exports__["Z"] = (getAdyenModule);


/***/ }),

/***/ 46857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ countingNumbersAsDropdownList; }
/* harmony export */ });
var countingNumbersArray = function(length) {
    return Array.from({
        length: length
    }, function(_, i) {
        return i + 1;
    });
};
var countingNumbersAsDropdownList = function(length, quantitySelected) {
    return countingNumbersArray(typeof quantitySelected === "number" && quantitySelected > length ? quantitySelected : length).map(function(item) {
        return {
            value: item.toString(),
            label: item.toString(),
            disabled: typeof quantitySelected === "number" && quantitySelected > item && length < item
        };
    });
};


/***/ }),

/***/ 9688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ isCartInStock; }
/* harmony export */ });
var isCartInStock = function(cartResult) {
    var ref, ref1, ref2;
    // If the cart is fetching or has errored then we
    // don't know for sure that all items in the cart are in stock
    if (cartResult.fetching || cartResult.error) return false;
    // Check that every item is either a gift card or a product
    // where the inventory is greater than or equal to
    // the quantity of that product in the cart
    return (ref = cartResult.data) === null || ref === void 0 ? void 0 : (ref1 = ref.activeCart) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.products) === null || ref2 === void 0 ? void 0 : ref2.every(function(item) {
        return item.__typename === "GiftCardCartItem" || item.__typename === "ProductCartItem" && item.hasStock;
    });
};


/***/ }),

/***/ 50765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ isLongTermPreOrderPaymentMethod; },
/* harmony export */   "j": function() { return /* binding */ isLongTermPreOrder; }
/* harmony export */ });
var isLongTermPreOrder = function(cart) {
    var ref, ref1, ref2;
    if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.longTermPreOrder) === null || ref === void 0 ? void 0 : ref.hasLongTermPreOrderItem) || !(cart === null || cart === void 0 ? void 0 : (ref1 = cart.longTermPreOrder) === null || ref1 === void 0 ? void 0 : ref1.longTermPreOrderItemPaymentMethods)) return false;
    return cart === null || cart === void 0 ? void 0 : (ref2 = cart.longTermPreOrder) === null || ref2 === void 0 ? void 0 : ref2.hasLongTermPreOrderItem;
};
var isLongTermPreOrderPaymentMethod = function(cart, paymentMethod) {
    var ref;
    if (!isLongTermPreOrder(cart)) return false;
    var longTermPreOrderItemPaymentMethods = (cart === null || cart === void 0 ? void 0 : (ref = cart.longTermPreOrder) === null || ref === void 0 ? void 0 : ref.longTermPreOrderItemPaymentMethods).split(",");
    return longTermPreOrderItemPaymentMethods.indexOf(paymentMethod) > -1;
};


/***/ }),

/***/ 40981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ canStartAppleSheet; },
/* harmony export */   "Mp": function() { return /* binding */ hasAllFieldsForTaxCalculation; },
/* harmony export */   "Nt": function() { return /* binding */ ensureAddressFields; },
/* harmony export */   "p_": function() { return /* binding */ transformShipmentMethod; }
/* harmony export */ });
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

var transformShipmentMethod = function(method) {
    var ref;
    return {
        label: method.name,
        amount: (ref = method.price) === null || ref === void 0 ? void 0 : ref.toString(),
        identifier: method.id,
        detail: method.id
    };
};
var ensureAddressFields = function(address) {
    return !!(address && address.administrativeArea && address.countryCode && address.familyName && address.givenName && address.locality && address.postalCode && address.addressLines && address.addressLines[0]);
};
var hasAllFieldsForTaxCalculation = function(event) {
    return !(!event.shippingContact.locality || !event.shippingContact.postalCode || !event.shippingContact.administrativeArea || !event.shippingContact.countryCode);
};
// NOTE: How to introduce conditional logic in mocks.
if (!utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk && "false" === "true") {}
var canStartAppleSheet =  false ? 0 : !utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk && window.location.href.startsWith("https") && !!window.ApplePaySession;


/***/ })

}]);